import { Modal, Typography } from '@smartgift/frontend-toolkit';
import isEqual from 'lodash/isEqual';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomizeMessageTable } from './CustomizeMessageTable';
import * as S from './style';

function CustomizeMessageModal({
  isOpen,
  setIsOpen,
  customizedRecipientMessages,
  updateCustomizedRecipientMessages,
  editable = true,
  ...props
}) {
  const { t } = useTranslation();
  const [customMessages, setCustomMessages] = useState({});

  const discardChanges = () => {
    if (updateCustomizedRecipientMessages)
      updateCustomizedRecipientMessages(customizedRecipientMessages);
    setCustomMessages({ ...customizedRecipientMessages });
    setIsOpen(false);
  };

  useEffect(() => {
    setCustomMessages({ ...customizedRecipientMessages });
  }, [customizedRecipientMessages]);

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      onRequestClose={discardChanges}
      title={t('customizeRecipientMessages')}
      primaryButtonProps={{
        children: editable ? t('saveChanges') : t('close'),
        onClick: () => {
          if (editable) {
            if (updateCustomizedRecipientMessages)
              updateCustomizedRecipientMessages(customMessages);
          }
          setIsOpen(false);
        },
        disabled: editable ? isEqual(customMessages, customizedRecipientMessages) : false
      }}
      secondaryButtonProps={{
        children: editable && t('cancel')
      }}
    >
      <S.CustomizeMessageModal>
        {editable && (
          <Typography variant="body1Bold">{t('customizeRecipientMessagesSubTitle')}</Typography>
        )}
        <CustomizeMessageTable
          customMessages={customMessages}
          setCustomMessages={setCustomMessages}
          editable={editable}
          {...props}
        />
      </S.CustomizeMessageModal>
    </Modal>
  );
}

export { CustomizeMessageModal };
